import { Link } from 'react-router-dom';
import './Header.css';

export default function Header() {
  return (
    <div className="header">
      <h1>
        <Link to="/">
          <span className="header-desktop">Ray Gonzalez Brown</span>
          <span className="header-mobile">Ray<br/>Gonzalez<br/>Brown</span>
        </Link>
      </h1>
      <nav>
        <Link to="/works">works</Link>
        <Link to="/projects">exhibitions</Link>
        <Link to="/about">about</Link>
        <Link to="/contact">contact</Link>
      </nav>
    </div>
  );
}
